export enum FileListMessages {
  ADD_URL_LABEL = 'Add URL',
  ADD_FILE_LABEL = 'Add file',
  UPLOAD_FILE_LABEL = 'Upload file',
  FILE_UPLOADED_LABEL = 'File uploaded by',
  FILE_SHARED_LABEL = 'Link shared by',
  OPEN_LABEL = 'Open',
}
